(function (angular) {
    'use strict';

    angular.module('apiSpaces')

        /**
         *
         */
        .factory('apiSpacesService',
            ['$http', '$q', 'portalConfig',
                function ($http, $q, portalConfig) {

                    var urlBase = portalConfig.urlBase;

                    var fac = {
                        getApiSpaces: getApiSpaces,
                        getApiSpacesWithStats: getApiSpacesWithStats,
                        getApiSpace: getApiSpace,
                        updateApiSpace: updateApiSpace,
                        createApiSpace: createApiSpace,
                        deleteApiSpace: deleteApiSpace
                    };

                    return fac;

                    /**
                     * Method to get ALL the api spaces from the paragom services.
                     * @returns {Promise} A promise that returns an array of api spaces
                     */
                    function getApiSpaces() {
                        return $http.get(urlBase + "/apispaces")
                            .then(getApiSpacesComplete)
                            .catch(getApiSpacesFailed);

                        function getApiSpacesComplete(response) {
                            return response.data;
                        }

                        function getApiSpacesFailed(error) {
                            console.error("getApiSpacesFailed", error);
                            return $q.reject(error);
                        }
                    }

                    /**
                     * Method to get ALL the api spaces from the paragom services.
                     * @returns {Promise} A promise that returns an array of api spaces
                     */
                    function getApiSpacesWithStats() {

                        return $http.get(urlBase + "/apispaces/stats")
                            .then(getApiSpacesComplete)
                            .catch(getApiSpacesFailed);

                        function getApiSpacesComplete(response) {
                            return response.data;
                        }

                        function getApiSpacesFailed(error) {
                            console.error("getApiSpacesFailed", error);
                            return $q.reject(error);
                        }
                    }
                    /**
                     * Method to get an api space from the paragom services.
                     * @param {string} id - the api space Id
                     * @returns {Promise} A promise that returns an api space
                     */
                    function getApiSpace(id) {

                        return $http.get(urlBase + "/apispaces/" + id)
                            .then(getApiSpaceComplete)
                            .catch(getApiSpaceFailed);

                        function getApiSpaceComplete(response) {
                            return response.data;
                        }

                        function getApiSpaceFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * PUT /apispace/{id}
                     * @param {string} id - the api space Id
                     * @param {string} name - the api space name
                     * @param {string} description - the api space description
                     */
                    function updateApiSpace(id, name, description) {
                        var request = {
                            name: name,
                            description: description
                        };

                        return $http.put(urlBase + "/apispaces/" + id, request)
                            .then(updateApiSpaceComplete)
                            .catch(updateApiSpaceFailed);

                        function updateApiSpaceComplete(response) {
                            return response.data;
                        }

                        function updateApiSpaceFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                    /**
                     * POST /apispaces/
                     * @param {string} name - the api space name
                     * @param {string} description - the api space description
                     */
                    function createApiSpace(name, description) {

                        var request = {
                            name: name,
                            description: description
                        };

                        return $http.post(urlBase + "/apispaces", request)
                            .then(createApiSpaceComplete)
                            .catch(createApiSpaceFailed);

                        function createApiSpaceComplete(response) {
                            return response.data;
                        }

                        function createApiSpaceFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function deleteApiSpace(apiSpaceId) {

                        return $http.delete(urlBase + "/apispaces/" + apiSpaceId)
                            .then(deleteApiSpaceComplete)
                            .catch(deleteApiSpaceFailed);

                        function deleteApiSpaceComplete(response) {
                            return response.data;
                        }

                        function deleteApiSpaceFailed(error) {
                            return $q.reject(error);
                        }
                    }
                }]);

})(window.angular);
